// UserDeleteConfirmationModal.tsx - Delete confirmation modal with AD guest removal warning
import React from 'react';
import './FocalPointsManagement.css';

interface UserDeleteConfirmationModalProps {
  isOpen: boolean;
  userName: string;
  isADGuest?: boolean;
  isDeleting?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UserDeleteConfirmationModal: React.FC<UserDeleteConfirmationModalProps> = ({
  isOpen,
  userName,
  isADGuest = false,
  isDeleting = false,
  onConfirm,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="delete-modal-overlay">
      <div className="delete-modal-container">
        <div className="delete-modal-content">
          <h2 className="delete-modal-title">Delete User</h2>
          <p className="delete-modal-message">
            Are you sure you want to delete user "<span className="user-name-highlight">{userName}</span>" and revoke their application access? This action cannot be undone.
          </p>
          
          {/* AD Guest Removal Warning */}
          {isADGuest && (
            <div className="ad-guest-warning">
              <span className="ad-guest-warning-icon">🔐</span>
              <p className="ad-guest-warning-text">
                This user has an Entra ID guest account. Deleting this user will also <strong>remove their guest account from Entra ID</strong>, revoking all Azure AD access.
              </p>
            </div>
          )}

          <div className="delete-modal-actions">
            <button
              onClick={onConfirm}
              className="btn-confirm-delete"
              type="button"
              disabled={isDeleting}
            >
              {isDeleting ? (
                <>
                  <span className="spinner-small"></span>
                  {isADGuest ? 'Removing...' : 'Deleting...'}
                </>
              ) : (
                isADGuest ? 'Delete User & Remove from AD' : 'Delete User'
              )}
            </button>
            <button
              onClick={onCancel}
              className="btn-cancel-delete"
              type="button"
              disabled={isDeleting}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};